// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"ExpandButton_expandButton__hV9TI"};